import { createFileRoute } from '@tanstack/react-router'
import { BrandPagesPage } from '@/features/brand-pages'

export const Route = createFileRoute('/_authenticated/brand-pages/')({
  component: BrandPagesPage,
})
